export const AUTH = 'AUTH';
export const CREATE = 'CREATE';
export const UPDATEPROFILE = 'UPDATEPROFILE';
export const FETCH = 'FETCH';
export const LOGOUT = 'LOGOUT';